import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { ContractService } from '../../services/contract.service';

@Component({
  selector: 'app-resign-confirmation-dialog',
  templateUrl: './resign-confirmation-dialog.component.html',
  styleUrls: ['./resign-confirmation-dialog.component.scss']
})
export class ResignConfirmationDialogComponent implements OnInit {

  constructor(
      public dialoge:MatDialog,
      public dialogRef: MatDialogRef<ResignConfirmationDialogComponent>,
      public notifier: NotifierService,
      private router: Router,
      public contractService: ContractService,
      @Inject(MAT_DIALOG_DATA) public data:any
  ) { }

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close("cancelled");
  }

  onSubmit(){
    this.dialogRef.close("confirmed");
  }

}
